import * as Type from '../actions/landingZoneMigration/types'

import { executeCallback, setInMemory } from '@services/store/utils'

import { LZ_INTERNET_MAIN } from '@features/hooks/LandingZones/migration'

const LOG_MODES = {
    [Type.MODE_LOG_APP]: 'app',
    [Type.MODE_LOG_NSG]: 'nsg'
}

const initialState = {
    data: {},
    selected: {
        steps: [],
        lzId: null,
        inProgress: false,
        mode: LZ_INTERNET_MAIN,
        step: '',
        interLzs: [],
        defaultRoutes: false,
        displayFooter: false,
        isCompleted: false,
        status: 'NOT_MIGRATED',
        logs: {
            nsg: [],
            app: []
        }
    },
    loaded: null
}

export default function LandingZoneMigrationReducer(state = initialState, action) {
    if (action.type === Type.POPULATE) {
        return executeCallback(
            setInMemory(state, action, 'data'),
            action,
            'landingZoneMigration'
        )
    }
    else if (action.type === Type.SET_STEP) {
        return executeCallback(
            setInMemory(state, action, 'selected', 'step'),
            action,
            'landingZoneMigration'
        )
    }
    else if (action.type === Type.SET_MODE) {
        return executeCallback(
            setInMemory(state, action, 'selected', 'mode'),
            action,
            'landingZoneMigration'
        )
    }
    else if (action.type === Type.SET_IN_PROGRESS) {
        return executeCallback(
            setInMemory(state, action, 'selected', 'inProgress'),
            action,
            'landingZoneMigration'
        )
    }
    else if (action.type === Type.SET_DISPLAY_FOOTER) {
        return executeCallback(
            setInMemory(state, action, 'selected', 'displayFooter'),
            action,
            'landingZoneMigration'
        )
    }
    else if (action.type === Type.SET_LOGS) {
        return executeCallback(
            setInMemory(state, action, 'selected', 'logs', LOG_MODES[action.mode]),
            action,
            'landingZoneMigration'
        )
    }
    else if (action.type === Type.SET_INTERLZS) {
        return executeCallback(
            setInMemory(state, action, 'selected', 'interLzs'),
            action,
            'landingZoneMigration'
        )
    }
    else if (action.type === Type.SET_DEFAULT_ROUTES) {
        return executeCallback(
            setInMemory(state, action, 'selected', 'defaultRoutes'),
            action,
            'landingZoneMigration'
        )
    }
    else if (action.type === Type.SET_SELECTED) {
        return executeCallback(
            setInMemory(state, action, 'selected'),
            action,
            'landingZoneMigration'
        )
    }
    else if (action.type === Type.SET_LOADED) {
        return executeCallback(
            setInMemory(state, action, 'loaded'),
            action,
            'landingZoneMigration'
        )
    }

    return state
}
